export default __webpack_public_path__ + "static/media/Group83.ec133af3.svg";